module.exports = __webpack_public_path__ + "img/094c990.jpg";